import * as tslib_1 from "tslib";
import folderPrefetchedAction from './folderPrefetchedAction';
import initializeFrequentlyUsedFolders from './initializeFrequentlyUsedFolders';
import { getStore } from '../store/store';
import * as filteredFUFFolderUtil from '../utils/filteredFUFFolderUtil';
import { logUsage } from 'owa-analytics';
import { isFolderPersonaFavoriteSearchFolder } from 'owa-favorites';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import loadInitialRowsFromServer from 'owa-mail-list-actions/lib/actions/table/loadInitialRowsFromServer';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { getTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import onInitialTableLoadComplete from 'owa-mail-table-loading-actions/lib/actions/onInitialTableLoadComplete';
import prefetch from 'owa-service/lib/prefetch';
import { action } from 'satcheljs/lib/legacy';
import updateTablesInCache, { canAddToMruTableIdList, } from 'owa-mail-list-actions/lib/actions/helpers/tableCache/updateTablesInCache';
// prefetch frequently used folders and add them to mru cache
export default action('prefetchFrequentlyUsedFolders')(function prefetchFrequentlyUsedFolders() {
    var FOLDER_PREFETCH_DELAY_MS = 10000;
    initializeFrequentlyUsedFolders();
    setTimeout(prefetchFoldersInternal, FOLDER_PREFETCH_DELAY_MS);
});
function prefetchFoldersInternal() {
    var MAX_FOLDERS_TO_PREFETCH = 5;
    var store = getStore();
    var folderCount = Math.min(MAX_FOLDERS_TO_PREFETCH, store.frequentlyUsedFolders.length);
    prefetch(function () {
        for (var i = 0; i < folderCount; i++) {
            var folderId = store.frequentlyUsedFolders[i].FolderId;
            var tableQuery = null;
            if (filteredFUFFolderUtil.isFilteredFolder(folderId)) {
                var filteredFolderProps = filteredFUFFolderUtil.getFilterTypeAndValueForFilteredFolder(folderId);
                if (!(filteredFolderProps &&
                    filteredFUFFolderUtil.shouldPrefetchFilteredFolder(filteredFolderProps.filterType))) {
                    continue;
                }
                tableQuery = filteredFUFFolderUtil.getTableQueryForFilteredFolder(filteredFolderProps);
            }
            else {
                // VSO 30372: update FUF list when a folder/category is deleted
                tableQuery = createMailFolderTableQuery(folderId, getListViewTypeForFolder(folderId), isFolderPersonaFavoriteSearchFolder(folderId) ? 'persona' : 'mail', -1 /* None */);
            }
            // TableQuery can be null when trying to prefetch a deleted filteredFolder
            if (!tableQuery) {
                continue;
            }
            var tableView = getTableViewFromTableQuery(tableQuery);
            var selectedTableView = getSelectedTableView();
            // Prefetch folder only if it is not already selected and
            // if MRU table list has not reached max capacity
            if (selectedTableView &&
                selectedTableView.id != tableView.id &&
                canAddToMruTableIdList()) {
                // Update table cache list
                if (updateTablesInCache(tableView) == -1) {
                    loadInitialRowsFromServer(tableView, true /* isTablePrefetched */, onInitialTableLoadComplete);
                    folderPrefetchedAction(folderId);
                }
            }
        }
        logFrequentlyUsedFoldersCount(folderCount);
    });
}
function logFrequentlyUsedFoldersCount(maxFolderCountToPrefetch) {
    var store = getStore();
    logUsage('prefetchFrequentlyUsedFolders_count', {
        total: maxFolderCountToPrefetch,
        personaTotal: store.frequentlyUsedFolders
            .slice(0, maxFolderCountToPrefetch)
            .filter(function (folder) { return isFolderPersonaFavoriteSearchFolder(folder.FolderId); }).length,
        allPrefetched: store.prefetchedFolderIds.size,
        personaPrefetched: tslib_1.__spread(store.prefetchedFolderIds.keys()).filter(function (folderId) {
            return isFolderPersonaFavoriteSearchFolder(folderId);
        }).length,
    });
}
//# sourceMappingURL=prefetchFrequentlyUsedFolders.js.map